import React, { useState, useEffect } from 'react';
import { Users, FileText, CheckCircle, Clock } from 'lucide-react';
import { supabase } from '../../../lib/supabase';
import StatCard from './StatCard';
import StatsLoader from './StatsLoader';

interface Stats {
  totalRequests: number;
  pendingRequests: number;
  completedRequests: number;
  publishedPosts: number;
}

export default function StatsOverview() {
  const [stats, setStats] = useState<Stats>({
    totalRequests: 0,
    pendingRequests: 0,
    completedRequests: 0,
    publishedPosts: 0
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchStats();
  }, []);

  async function fetchStats() {
    try {
      const [
        { count: totalRequests },
        { count: pendingRequests },
        { count: completedRequests },
        { count: publishedPosts }
      ] = await Promise.all([
        supabase.from('service_requests').select('*', { count: 'exact' }),
        supabase.from('service_requests').select('*', { count: 'exact' }).eq('status', 'pending'),
        supabase.from('service_requests').select('*', { count: 'exact' }).eq('status', 'completed'),
        supabase.from('blog_posts').select('*', { count: 'exact' }).eq('status', 'published')
      ]);

      setStats({
        totalRequests: totalRequests || 0,
        pendingRequests: pendingRequests || 0,
        completedRequests: completedRequests || 0,
        publishedPosts: publishedPosts || 0
      });
    } catch (error) {
      console.error('Error fetching stats:', error);
    } finally {
      setLoading(false);
    }
  }

  if (loading) {
    return <StatsLoader />;
  }

  const statCards = [
    {
      title: 'Total Requests',
      value: stats.totalRequests,
      icon: Users,
      color: 'bg-blue-500'
    },
    {
      title: 'Pending Requests',
      value: stats.pendingRequests,
      icon: Clock,
      color: 'bg-yellow-500'
    },
    {
      title: 'Completed Requests',
      value: stats.completedRequests,
      icon: CheckCircle,
      color: 'bg-green-500'
    },
    {
      title: 'Published Posts',
      value: stats.publishedPosts,
      icon: FileText,
      color: 'bg-purple-500'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
      {statCards.map((stat, index) => (
        <StatCard key={index} {...stat} />
      ))}
    </div>
  );
}